export const SIDEBAR_NAMES = {
  NEW_CHAT: "sideMenu.newChat",
  CHAT_HISTORY: "sideMenu.chatHistory",
  FAQ: "sideMenu.faq",
  CONTACT: "sideMenu.contact",
  TERMS_CONDITION: "sideMenu.terms",
  PRIVACY_POLICY: "sideMenu.privacy",
  SETTINGS: "sideMenu.setting",
};

export enum SIDEBAR_ICON_NAMES {
  NEW_CHAT = "NewChat",
  CHAT_HISTORY = "ChatHistory",
  FAQ = "FAQ",
  CONTACT = "Contact",
  TERMS_CONDITION = "TermsCondition",
  PRIVACY_POLICY = "PrivacyPolicy",
  SETTINGS = "Settings",
}

export enum ROUTE_NAMES {
  HOME = "/",
  LOGIN = "/login",
  SINGUP = "/signup",
  NOTICE = "/notice",
  UNAUTHENTICATED_COURSES = "/unauthenticated/courses",
  UNAUTHENTICATED_COURSE_DETAIL = "/unauthenticated/course-detail",
  UNAUTHENTICATED_NOTICE = "/unauthenticated/notice",
  SUPER_ADMIN_PROFILE = "/super-admin/profile",
  JOURNALIST_COURSE_DETAIL = "/journalist/course-detail",
  SUPER_ADMIN_UPDATE_PROFILE = "/super-admin/update-profile",
  ADMIN_JOURNALIST_MANAGEMENT = "/admin/journalist-management",
  SIGNUP_EMAIL_VERIFICATION = "/signup-email-verification",
  AWAITING_APPROVAL = "/awaiting",
  ADMIN_NOTICE = "/admin/notice",
  FORGET_PASSWORD = "/admin/forgot-password",
  RESET_PASSWORD = "/reset-password",
  RESET_SUCCESS = "/reset-success",
  ACCOUNT_SUCCESS = "/account-success",
  CHECK_YOUR_EMAIL = "/check-your-email",
  EMAIL_VERIFICATION = "/email-verification",
  DASHBOARD = "/dashboard",
  SUPER_ADMIN_DASHBOARD = "/super-admin/dashboard",
  SUPER_ADMIN_LOGIN = "/super-admin/login",
  CHAT_HISTORY = "/chatHistory",
  CUSTOMER_CENTER = "/customer-center",
  MY_LEARNING = "/my-learning",
  PRIVACY_POLICY = "/privacyPolicy",
  TERMS_CONDITION = "/termsconditions",
  USER_PROFILE = "/admin/my-profile",
  UPDATE_PROFILE = "/admin/update-profile",
  PPT_DASHBOARD_PREVIEW = "/ppt-dashboard-preview",
  PPT_PREVIEW = "/ppt-preview",
  FAQ = "faqs",
  CONTACT = "/contactUs",
  CHAT_BY_ID = "/chat/:id",
  SETTINGS = "/settings",
  API_DASHBOARD = "/api-dashboard",
  SHARED_CHAT = "/shared/chat/:uid",
  SHARED_THREAD = "/thread/:thraedUID",
  USER_SUBSCRIPTION = "/admin/usersubscription",
  SUBSCRIPTION_SUCCESS = "/subscription-success",
  MY_DOCUMENT = "/my-document",
  ADMIN_USERS_MANAGMENT = "users/manage",
  CONGPT_CHAT_SCREEN = "/c/congpt",
  KSCE_CHAT_SCREEN = "/c/kpsgpt",
  ALL_SET = "/all-set",
  LETS_START = "/lets-start",
  ADMIN_ANALYTICS = "/admin/analytics",
  ADMIN_LOGIN = "/admin/login",
  RISKCHECKER_CHAT_SCREEN = "/c/risk-checker",
  COURSES = "/courses",
  COURSE_MANAGEMENT = "/admin/course-management",
  CATEGORY_MANAGEMENT = "/admin/category-management",
  COURSE_CREATE = "/admin/course-management/create",
  COURSE_EDIT = "/admin/course-management/edit/:id",
  FAQS = "/admin/faqs",
  SUBSCRIBER_COURSE = "subscriber/:userid/courses",
  SUBSCRIBER_MEMBERS = "subscriber/:userid/members",
  COURSE_SET_PREFERENCE = "/admin/course-management/set-preference",
  PLEDGE = "/pledge",
  PLEDGE_LOGIN = "/pledge/login",
  PLEDGE_DASHBOARD = "/pledge/dashboard",
  PLEDGE_COURSES = "/pledge/courses",
  PLEDGE_MEMBERS_LISTING = "/pledge/members-listing",
  PLEDGE_NOTIFICATIONS = "/pledge/notifications",
  PLEDGE_PROFILE = "/pledge/profile",
  PLEDGE_UPDATE_PROFILE = "/pledge/update-profile",
  JOURNALIST_MANAGEMENT = "/pledge/journalist-management",
  PLEDGE_ALL_NOTICES = "/pledge/all/notices",
  PLEDGE_JOURNALIST_LIST = "/pledge/journalist-list",
  DEPARTMENT_MANAGEMENT = "/pledge/department-management",
  JOURNALIST_LOGIN = "/login",
  JOURNALIST_SIGNUP = "/signup",
  JOURNALIST_DASHBOARD = "/dashboard",
  JOURNALIST_COURSES = "/courses",
  JOURNALIST_LEARNING = "/journalist/learning",
  JOURNALIST_CUSTOMER_CENTER = "/customer-center",
  JOURNALIST_EMAIL_VERIFICATION = "/email-verification",
  JOURNALIST_NOTICE = "/journalist/notice",
  JOURNALIST_PROFILE = "/journalist/profile",
  JOURNALIST_UPDATE_PROFILE = "/journalist/update-profile",
  SUBSCRIBER_COURSE_ADMIN = "/admin/subscriber/:userid/courses",
  SUBSCRIBER_MEMBERS_ADMIN = "/admin/subscriber/:userid/members",
  SUB_SUBSCRIBER_MANAGEMENT = "/pledge/sub-subscriber-management",
}
